import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=54884c0e&scoped=true&lang=pug"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=54884c0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54884c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54884c0e')) {
      api.createRecord('54884c0e', component.options)
    } else {
      api.reload('54884c0e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=54884c0e&scoped=true&lang=pug", function () {
      api.rerender('54884c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Accordion.vue"
export default component.exports